/**
 * Services.
 *
 * Previously a bundled constant. Now served from the CMS, so the navigation,
 * the homepage grid, the footer and the quote form's picker all reflect what
 * the business has actually published.
 *
 * `SERVICES` remains the offline fallback: if the API is unreachable the site
 * still renders its service menu rather than an empty header.
 */
import { api, withFallback } from "./api";
import { SERVICES } from "../data/services";

/** Shapes the bundled fallback like the API response. */
const fallbackList = () =>
  SERVICES.map((service, index) => ({
    id: service.slug,
    name: service.name,
    slug: service.slug,
    route: `/${service.slug}`,
    group: "After Renovation",
    shortDescription: service.shortDescription ?? "",
    heroHeadline: service.name,
    heroIntro: service.shortDescription ?? "",
    heroImage: service.heroImage,
    checklist: [],
    process: [],
    pricingFactors: [],
    faqs: [],
    related: [],
    displayOrder: index + 1,
    active: true,
  }));

export const serviceService = {
  list: () => withFallback(() => api.get("/services"), fallbackList()),

  /** Grouped for the navigation dropdown. */
  nav: () =>
    withFallback(
      () => api.get("/services/nav"),
      [{ group: "Services", items: fallbackList().map((s) => ({ name: s.name, route: s.route, shortDescription: s.shortDescription })) }]
    ),

  /** One service with its related services resolved. Null when not found. */
  detail: (slug) =>
    withFallback(
      () => api.get(`/services/${slug}`),
      fallbackList().find((service) => service.slug === slug) ?? null
    ),
};
